import React from 'react';

const Privacy = () => {
  return (
    <div style={{ padding: '3rem 1.5rem', maxWidth: '800px', margin: '0 auto', fontFamily: 'Inter, sans-serif', color: '#334155', lineHeight: '1.7' }}>
      <h1 style={{ color: '#0b2545', borderBottom: '1px solid #ddd', paddingBottom: '1rem' }}>Privacy Policy</h1>
      <p style={{ fontSize: '0.9rem', color: '#64748b' }}>Last Updated: January 2026</p>

      <h3>1. Scope of Data Collection</h3>
      <p>This website is purely informational. <strong>We do not require you to create an account, log in, or upload documents directly to this website.</strong></p>
      <p>We only collect information that you voluntarily provide to us when you contact us via email, phone, or messaging services to inquire about our services.</p>

      <h3>2. Information We may Process</h3>
      <ul>
        <li><strong>Contact Information:</strong> Name, email address, and phone number (if you email/call us).</li>
        <li><strong>Correspondence:</strong> Any details you choose to share regarding your legal queries in your email communications.</li>
      </ul>

      <h3>3. How We Use Information</h3>
      <p>We use the contact information solely to:</p>
      <ul>
        <li>Respond to your inquiries and service requests.</li>
        <li>Schedule consultations (conducted via Zoom/Google Meet or in-person).</li>
        <li>Send invoices or engagement letters upon your request.</li>
      </ul>

      <h3>4. Data Security</h3>
      <p>While this website does not store personal data, we treat all client communications with strict confidentiality. Any sensitive legal documents shared via email are handled in accordance with professional attorney-client privilege standards.</p>

      <h3>5. Cookies</h3>
      <p>This website may use standard cookies to ensure the site functions correctly. These do not track your personal activities outside of this website.</p>

      <h3>6. Contact Us</h3>
      <p>For any privacy concerns, please contact our Grievance Officer:</p>
      <div style={{ marginTop: '1rem', padding: '1rem', background: '#f1f5f9', borderRadius: '8px' }}>
        <strong>Name:</strong> Rushil Aiya<br/>
        <strong>Email:</strong> support@abhikalpconsulting.com
      </div>
    </div>
  );
};

export default Privacy;